<template>
  <div class="mul-alarm-page">
    <div class="page-scroll">
      <div class="filter-section">
        <div class="tenant-range-row" @click="openTenantPicker">
          <van-icon name="friends-o" class="range-icon" />
          <span class="range-label">租户</span>
          <span class="range-value">{{ tenantDisplayText }}</span>
          <van-icon name="arrow-down" class="range-arrow" />
        </div>

        <van-action-sheet
          v-model="showTenantPicker"
          :actions="tenantActions"
          cancel-text="取消"
          description="请选择租户"
          close-on-click-action
          @select="onTenantSelect"
        />

        <div class="time-actions">
          <van-button type="primary" block class="query-btn" @click="queryAlarms">
            <van-icon name="search" />
            <span>查询</span>
          </van-button>
        </div>
      </div>

      <div class="status-tabs">
        <div class="status-tab" :class="{ active: activeStatus === '0' }" @click="switchStatus('0')">
          <span class="tab-title">待处理</span>
          <span class="tab-count">{{ pendingCount }}</span>
        </div>
        <div class="status-tab" :class="{ active: activeStatus === '1' }" @click="switchStatus('1')">
          <span class="tab-title">已处理</span>
          <span class="tab-count">{{ processedCount }}</span>
        </div>
      </div>

      <alarm-list-panel
        :items="alarmList"
        :status="activeStatus"
        :loading.sync="loading"
        :finished="finished"
        :refreshing.sync="refreshing"
        @load="loadMore"
        @refresh="onRefresh"
        @open-handle="handleAlarm"
        @show-detail="handleView"
      />
    </div>

    <AlarmDetailPopup v-model="dialogVisible" mode="handle" :alarm-data="formData" @submit="submitForm"/>

    <AlarmDetailPopup v-model="viewDialog" mode="detail" :alarm-data="formView"/>

    <tabular mode="manage" :active="0" />
  </div>
</template>

<script>
import Tabular from '@/components/tabbar';
import AlarmListPanel from '@/components/alarm/AlarmListPanel';
import AlarmDetailPopup from '@/components/alarm/AlarmDetailPopup';
import { Toast } from 'vant';
import _ from 'lodash';
import { tenantData } from '@/utils/tenantUtils';
import $ from '@/fly';

export default {
  name: 'mul-alarm-info',
  components: { Tabular, AlarmListPanel, AlarmDetailPopup },
  data() {
    return {
      tenantList: tenantData.getTenantList(),
      showTenantPicker: false,
      selectedTenant: '',
      isAllTenants: true,
      activeStatus: '0',
      pendingCount: 0,
      processedCount: 0,
      alarmList: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1,
      pageSize: 10,
      dialogVisible: false,
      viewDialog: false,
      formData: { userName: '', measures: '' },
      formView: {}
    }
  },
  computed: {
    tenantActions() {
      const actions = [
        {
          name: '全部租户',
          isAll: true,
          className: this.isAllTenants ? 'is-selected' : '',
          color: this.isAllTenants ? '#1B75F6' : ''
        }
      ];
      this.tenantList.forEach(tenant => {
        const isSelected = !this.isAllTenants && tenant.equCode === this.selectedTenant;
        actions.push({
          name: tenant.tenantName,
          tenant: tenant,
          className: isSelected ? 'is-selected' : '',
          color: isSelected ? '#1B75F6' : ''
        });
      });
      return actions;
    },
    tenantDisplayText() {
      if (this.isAllTenants) {
        return '全部租户';
      }
      const tenant = this.tenantList.find(t => t.equCode === this.selectedTenant);
      return tenant ? tenant.tenantName : '请选择租户';
    },
  },
  mounted() {
    this.loadTenants();
    this.$nextTick(() => {
      this.initData();
    });
  },
  methods: {
    loadTenants() {
      this.isAllTenants = true;
      this.selectedTenant = '';
    },
    openTenantPicker() {
      this.showTenantPicker = true;
    },
    onTenantSelect(action) {
      if (action.isAll) {
        this.isAllTenants = true;
        this.selectedTenant = '';
      } else if (action.tenant && action.tenant.equCode) {
        this.isAllTenants = false;
        this.selectedTenant = action.tenant.equCode;
      }
      this.queryAlarms();
    },
    getEquCodeParam() {
      if (this.isAllTenants) {
        return this.tenantList.map(t => t.equCode);
      }
      return this.selectedTenant ? [this.selectedTenant] : [];
    },
    initData() {
      this.queryAlarms();
    },
    queryAlarms() {
      const equCode = this.getEquCodeParam();
      if (!equCode || equCode.length === 0) {
        Toast('请选择租户');
        return;
      }
      this.pageNum = 1;
      this.finished = false;
      this.alarmList = [];
      this.$nextTick(() => {
        this.loadCounts();
        this.finished = true;
        this.loadAlarms();
      });
    },
    loadCounts() {
      $.get('mobile/alarm/alarmCounts', {
        equCode: this.getEquCodeParam()
      }).then(res => {
        this.pendingCount = res.data.pendingCount || 0;
        this.processedCount = res.data.processedCount || 0;
      })
    },
    loadAlarms(isRefresh) {
      if (!isRefresh) {
        this.loading = true;
      }
      $.get('mobile/alarm/alarmData', {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: this.activeStatus,
        equCode: this.getEquCodeParam()
      }).then(res => {
        const data = res.data || [];
        if (this.pageNum === 1) {
          this.alarmList = [...data];
        } else {
          this.alarmList = [...this.alarmList, ...data];
        }
        this.finished = data.length < this.pageSize;
        if (!this.finished) {
          this.pageNum++;
        }
        this.loading = false;
        this.refreshing = false;
      })
    },
    switchStatus(status) {
      if (this.activeStatus === status) return;
      this.activeStatus = status;
      this.pageNum = 1;
      this.finished = false;
      this.alarmList = [];
      this.$nextTick(() => {
        this.finished = true;
        this.loadAlarms();
      });
    },
    loadMore() {
      if (!this.finished && !this.refreshing) {
        this.loadAlarms();
      } else {
        this.loading = false;
      }
    },
    onRefresh() {
      this.loading = false;
      this.pageNum = 1;
      this.finished = true;
      this.alarmList = [];
      this.loadAlarms(true);
      this.loadCounts();
    },
    handleAlarm(item) {
      this.formData = _.cloneDeep(item);
      this.dialogVisible = true;
    },
    handleView(item) {
      this.formView = _.cloneDeep(item);
      this.viewDialog = true;
    },
    submitForm(formData) {
      $.post('mobile/alarm/dealAlarm', formData, { contentType: 'application/json' })
        .then(()=>{
          Toast.success('处理完成！');
          this.queryAlarms();
      }).finally(() => {
        this.dialogVisible = false;
      })
    },
  },
}
</script>

<style lang="less" scoped>
/* 页面占满视口，筛选区固定，列表区内部滚动 */
.mul-alarm-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #F5F7FA;
}

.page-scroll {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px;
}

.filter-section {
  flex-shrink: 0;
  background: #fff;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tenant-range-row,
.time-range-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 22px 20px;
  background: #F8FAFC;
  border-radius: 12px;
  cursor: pointer;
  min-height: 80px;
  box-sizing: border-box;

  &:active {
    background: #F0F2F5;
  }
}

.range-icon {
  color: #1B75F6;
  font-size: 32px;
  flex-shrink: 0;
}

.range-label {
  font-size: 28px;
  color: #1a365d;
  font-weight: 600;
  flex-shrink: 0;
  min-width: 72px;
}

.range-value {
  flex: 1;
  font-size: 28px;
  color: #303133;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

.range-sep {
  font-size: 26px;
  color: #909399;
  flex-shrink: 0;
}

.range-arrow {
  color: #909399;
  font-size: 28px;
  flex-shrink: 0;
}

.time-actions {
  padding: 4px 0 0;
}

.query-btn {
  height: 72px;
  border-radius: 36px;
  font-size: 30px;
  font-weight: 600;
  background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
  border: none;
  box-shadow: 0 4px 16px rgba(27, 117, 246, 0.3);

  .van-icon {
    margin-right: 8px;
  }
}

/deep/.van-action-sheet__action {
  font-size: 26px;
  min-height: 88px;
  line-height: 88px;

  &.is-selected {
    font-weight: 600;
    position: relative;
    background: linear-gradient(135deg, rgba(27, 117, 246, 0.08) 0%, rgba(74, 144, 226, 0.05) 100%);
    border-top: 1px solid rgba(27, 117, 246, 0.1);
    border-bottom: 1px solid rgba(27, 117, 246, 0.1);
  }

  &.is-selected::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 6px;
    height: 36px;
    background: linear-gradient(to bottom, #1B75F6, #4A90E2);
    border-radius: 0 4px 4px 0;
  }

  &.is-selected::after {
    content: '\2713';
    position: absolute;
    right: 32px;
    top: 50%;
    transform: translateY(-50%);
    color: #1B75F6;
    font-weight: bold;
    font-size: 32px;
  }
}

.status-tabs {
  display: flex;
  background: #fff;
  border-radius: 14px;
  padding: 6px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  flex-shrink: 0;
}

.status-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 0;
  font-size: 28px;
  color: #64748B;
  border-radius: 10px;
  transition: all 0.3s;

  &.active {
    background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
    color: #fff;
    font-weight: 600;
  }

  .tab-count {
    font-size: 24px;
    padding: 2px 12px;
    border-radius: 12px;
    background: #F1F5F9;
    color: #FF4D4F;

    .active & {
      background: rgba(255, 255, 255, 0.25);
      color: #fff;
    }
  }
}
</style>
